import script from "./permission_check.vue?vue&type=script&setup=true&lang=js"
export * from "./permission_check.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__